import { FormBuilderOptions } from '@b2b/common/components/form-builder/types';
import { popupCenter } from '@b2b/common/utils/popup';
import { TODO } from '@b2b/types/core';
import angular from 'angular';

export const FactoryFormsModule = angular
  .module('acme.common.factory.forms', ['acme.common.factory.QueryStringBuilder', 'acme.common.service.helpers'])
  .factory('FormsFactory', [
    'QueryStringBuilderFactory',
    'HelpersService',
    function FormsFactory(QueryStringBuilderFactory: TODO, HelpersService: TODO) {
      function Forms() {
        return {
          constructor: Forms,

          init: function () {
            if (!window.fbUtils) {
              this.fbUtilsHelper();
            }

            return true;
          },

          /**
           * Library is not loading properly
           * we should clean this up once we
           * figure out why it's not bootstrapping
           * fbUtils to the global scope
           */
          fbUtilsHelper: function () {
            // fbUtils appears undefined at this point
            window.fbUtils = {
              otherOptionCB: function (opt) {
                const check = $(`#${opt}`);
                const value = $(`#${opt}-value`);
                if (check.is(':checked')) {
                  value.show();
                }
              },
            };
          },

          getDefaultNamedPreferences: function () {
            return {
              b2c: 'required',
              pos: 'displayed',
            };
          },

          getDefaultObjectPreferences: function () {
            return {
              b2c: {
                display: true,
                required: true,
              },
              pos: {
                display: true,
                required: false,
              },
            };
          },

          updatePreferences: function (channel, preferences) {
            const r = {
              pos: 'none',
              b2c: 'none',
            };

            if (channel === 'b2c') {
              preferences.required = preferences.display;
            }

            if (preferences.display && preferences.required) {
              r[channel] = 'required';
            } else if (preferences.display && !preferences.required) {
              r[channel] = 'displayed';
            } else if (!preferences.display) {
              r[channel] = 'none';
            }

            return r;
          },

          restorePreferences: function (preferences) {
            const r = {
              b2c: {
                display: false,
                required: false,
              },
              pos: {
                display: false,
                required: false,
              },
            };

            const channels = ['pos', 'b2c'];

            if (preferences) {
              for (let i = 0, ii = channels.length; i < ii; i++) {
                switch (preferences[channels[i]].toLowerCase()) {
                  case 'displayed':
                    r[channels[i]].display = true;
                    r[channels[i]].required = channels[i] === 'b2c';
                    break;
                  case 'required':
                    r[channels[i]].display = true;
                    r[channels[i]].required = true;
                    break;
                  case 'none':
                    r[channels[i]].display = false;
                    r[channels[i]].required = false;
                    break;
                }
              }
            }

            return r;
          },

          previewForm: function (data) {
            const wHeight = HelpersService.clamp(window.screen.availHeight, 0, 1280) - 20;
            const wWidth = HelpersService.clamp(window.screen.availWidth, 0, 1280) - 20;

            const qs = new QueryStringBuilderFactory({
              props: data,
              fields: {
                optional: ['eventName', 'eventStartTime', 'eventEndTime'],
              },
            });
            const q = qs.query;

            popupCenter({
              url: `/app/forms/preview/${data.formId}` + q,
              title: 'form-preview',
              height: wHeight,
              width: wWidth,
            });
          },

          renderForm: function (config) {
            const container = $(`#${config.containerId}`);
            const options: FormBuilderOptions = {
              dataType: 'json',
              formData: config.sourceFormDefinition ? config.sourceFormDefinition : '[]',
              typeUserAttrs: {
                text: {
                  dataCustomField: {
                    label: 'Custom Field',
                    options: config.customFields,
                  },
                },
                textarea: {
                  dataCustomField: {
                    label: 'Custom Field',
                    options: config.customFields,
                  },
                },
                number: {
                  dataCustomField: {
                    label: 'Custom Field',
                    options: config.customFields,
                  },
                },
                hidden: {
                  dataCustomField: {
                    label: 'Custom Field',
                    options: config.customFields,
                  },
                },
                file: {
                  dataCustomField: {
                    label: 'Custom Field',
                    options: config.customFields,
                  },
                },
                date: {
                  dataCustomField: {
                    label: 'Custom Field',
                    options: config.customFields,
                  },
                },
                select: {
                  dataCustomField: {
                    label: 'Custom Field',
                    options: config.customFields,
                  },
                },
                autocomplete: {
                  dataCustomField: {
                    label: 'Custom Field',
                    options: config.customFields,
                  },
                },
                checkbox: {
                  dataCustomField: {
                    label: 'Custom Field',
                    options: config.customFields,
                  },
                },
                'checkbox-group': {
                  dataCustomField: {
                    label: 'Custom Field',
                    options: config.customFields,
                  },
                },
                radio: {
                  dataCustomField: {
                    label: 'Custom Field',
                    options: config.customFields,
                  },
                },
                'radio-group': {
                  dataCustomField: {
                    label: 'Custom Field',
                    options: config.customFields,
                  },
                },
              },
            };

            return (container as TODO).formRender(options);
          },
        };
      }

      return Forms;
    },
  ]).name;
